import {clientStaffRoutes} from '../utils';
import ExpensesTable from '@/views/expenses/ExpensesTable.vue';
import ExpensesCard from '@/views/expenses/ExpensesCard.vue';

export default [
   ...clientStaffRoutes({
      name: 'contractors-table',
      path: '/contractors-table',
      component: ExpensesTable,
      props: {expenseType: 'contractors'},
      stage: 'contractors',
      breadCrumb: [
         {text: 'Dashboard', to: {name: 'Home'}},
         {text: '__COMPANYNAME__', to: {name: 'company-detail', params: {id: 'FILL'}}},
         {text: 'Contract Research'},
      ],
   }),
   ...clientStaffRoutes({
      name: 'contractors-period-review',
      path: '/contractors/:periodId/company',
      component: ExpensesCard,
      props: {expenseType: 'contractors'},
      stage: 'contractors',
      breadCrumb: [
         {text: 'Dashboard', to: {name: 'Home'}},
         {text: '__COMPANYNAME__', to: {name: 'company-detail', params: {id: 'FILL'}}},
         {text: 'Contract Research', to: {name: 'contractors-table-staff', params: {id: 'FILL'}}},
         {text: 'Contract Research - Review'},
      ],
   }),
];
